module.exports = __webpack_public_path__ + "static/media/27337059_1966554326941663_6174516189159973921_n.304007e0.jpg";